import React, { createContext, useContext } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { getConfig } from '../config';
const CustomAuthContext = createContext({});
const RelyantAuthProvider = ({ networkConfig, children }) => {
    const config = networkConfig || getConfig();
    return (React.createElement(CustomAuthContext.Provider, { value: {} },
        React.createElement(Auth0Provider, { domain: config.domain, clientId: config.clientId, authorizationParams: {
                redirect_uri: window.location.origin,
                audience: config.audience ? config.audience : null,
                // The Gmail toggle in Auth0 dashboard is ON.
                // This causes to ask for an aggressive permission when logging in.
                // We can create a custom connection in Auth0, invoke the google custom authorization URL
                // with more granular scopes and update the Gmail toggle to OFF.
                // With this approach the email prompt will be removed during login,
                // and in the Integration page it will only ask for those permissions
                scope: 'openid email profile offline_access',
                access_type: 'offline',
                prompt: 'consent',
            } }, children)));
};
const useRelyantAuth = () => useContext(CustomAuthContext);
export { RelyantAuthProvider, useRelyantAuth };
